import { html, node } from 'wirejs-dom/v2';
import { PricingTable } from '../ui/pricing-table';
import { ProFeatures } from '../../services';
import Alert from '../ui/alert';
import Confirmation from '../ui/confirmation';
import Spinner from '../ui/spinner';

function reportFailure() {
	new Alert({
		message: `<h3>Cancel failed.</h3>
			<p>Contact us at <a href='mailto:admin@deckanalyzer.com'>admin@deckanalyzer.com</a>
			if it continues to fail.</p>`
	});
};

export const AccountStatus = function() {
	return html`<db:accountstatus style='text-align: center;'>
		${node('productTable', html`<div>Loading status ...</div>`)}
		<h3>Current Subscriptions</h3>
		${node('subscriptions', html`<div>Loading subscriptions ...</div>`)}
	</db:accountstatus>`.onadd(async self => {
		const userFeaturesPromise = ProFeatures.getFeatures();
		const subsPromise = ProFeatures.getActiveSubscription();

		self.data.productTable = PricingTable(await userFeaturesPromise);
		
		self.data.subscriptions = (await subsPromise).length > 0 ? html`<div>
			${(await subsPromise).map(sub => {
				const pricing = `${(sub.plan.amount / 100).toFixed(2)}/${sub.plan.interval}`;
				const name = `${sub.product.name}`;

				const cancel = async (evt) => {
					evt.target.disabled = true;
					const spinner = new Spinner({
						message: `Cancelling ...`
					});
					try {
						if (await ProFeatures.cancelSubscription(sub.id)) {
							setTimeout(() => document.location.reload(), 3000);
						} else {
							spinner.close();
							reportFailure();
						}
					} catch {
						spinner.close();
						reportFailure();
					}
				};

				const startCancellation = (evt) => {
					const confirmation = new Confirmation();
					on(confirmation, 'yes').then(() => {
						cancel(evt)
					});
				};

				return html`<div>
					<b>${name}</b> at ${pricing}
					<button onclick=${startCancellation}>Cancel</button>
				</div>`;
			})}
		</div>` : html`<div><i>None</i></div>`;
	});
};
